// Floating menus: a button with data-n-menu-trigger="menu-id" toggles <div id="menu-id" class="n-menu" hidden>.
// The menu opens beside the trigger, closes on Escape or a click outside.
import { $, $$ } from './dom';

function placeBeside(menu: HTMLElement, trigger: HTMLElement): void {
	const r = trigger.getBoundingClientRect();
	const right = r.right + 12 + menu.offsetWidth < window.innerWidth;
	menu.style.left = right
		? `${r.right + 12}px`
		: `${Math.max(12, Math.min(r.left, window.innerWidth - menu.offsetWidth - 12))}px`;
	// Below the trigger when it fits, else above it (a menu low on the page must not run off the window).
	const below = r.bottom + 8 + menu.offsetHeight <= window.innerHeight - 12;
	menu.style.top = right
		? `${Math.min(window.innerHeight - menu.offsetHeight - 12, Math.max(12, r.top))}px`
		: `${below ? r.bottom + 8 : Math.max(12, r.top - 8 - menu.offsetHeight)}px`;
}

export function initMenus(): void {
	document.addEventListener('click', (e) => {
		const trigger = (e.target as Element).closest<HTMLElement>('[data-n-menu-trigger]');
		for (const menu of $$('.n-menu:not([hidden])')) {
			if (!menu.contains(e.target as Node) && menu.id !== trigger?.dataset.nMenuTrigger) menu.hidden = true;
		}
		if (!trigger) return;
		const menu = $(`#${trigger.dataset.nMenuTrigger}`);
		if (!menu) return;
		// A menu inside a card (backdrop-filter makes the card the containing block for fixed
		// descendants) would be placed relative to the card, not the window: move it to <body>.
		if (menu.parentElement !== document.body) document.body.append(menu);
		menu.hidden = !menu.hidden;
		trigger.setAttribute('aria-expanded', String(!menu.hidden));
		if (!menu.hidden) placeBeside(menu, trigger);
	});
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') for (const menu of $$('.n-menu:not([hidden])')) menu.hidden = true;
	});
}
